<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Informasi Umum</h5>
            </template>
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Filter" 
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-select class="ml-2 mr-2" v-model="input.filterJenis" id="filterInput" name="jenisinformasi" :options="jenisinformasi" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Pilih filter jenis --</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-form-input class="mr-2" 
                            v-model="input.filterTitle" name="filterTable"
                            type="search"
                            placeholder="Type to search"
                        >
                        </b-form-input>
                        <b-form-select v-if="credential.id == 1" class="ml-2 mr-2" v-model="input.filterIsActive" id="filterIsActive" name="filterIsActive" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Pilih filter status --</b-form-select-option>
                                <b-form-select-option :value="true" >Aktif</b-form-select-option>
                                <b-form-select-option :value="false" >Non-Aktif</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter"> 
                            <i class="fa fa-search"></i>
                        </b-button>
                        <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                    </div>
                </b-form-group>
                
                <b-button v-if="credential.id == 1" class="mb-3" name="informasiUmumAddBtn" variant="pgiBtn" @click="inputinformasiUmum">Input Informasi Umum</b-button>
            </div>
        
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="listinformasi" 
                :fields="fields"
                :no-local-sorting="false"
                @sort-changed="sortingChanged" 
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data informasi umum.
                </template>
                <template v-slot:cell(tanggalRilis)="row">
                    <div>{{$helper.changeDateFormat(row.item.tanggalRilis)}}</div>
                    <div class="smallText text-muted">{{$helper.changeDateFormatGetHour(row.item.tanggalRilis)}}</div>
                </template>
                <template v-slot:cell(isActive)="row">
                    <b-badge v-if="row.item.isActive" variant="success">Aktif</b-badge>
                    <b-badge v-else variant="danger">Non-Aktif</b-badge>
                </template>

                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-button @click="getDetail(row.item.id)" size="sm" class="mr-3" variant="primary" v-b-tooltip.hover title="Detail" name="informasiUmumViewBtn">
                            <i class="px-1 fa fa-info"></i>
                        </b-button>    
                        <b-button v-if="credential.id == 1" @click="confSwitchStatus(row.item.id)" size="sm" variant="success" class="mr-3" :variant="row.item.isActive ?'danger' :'success'" v-b-tooltip.hover :title="row.item.isActive ?'Non-Aktifkan' :'Aktifkan'">
                            <i class="fa fa-power-off"></i>
                        </b-button>    
                    </div>
                </template>
            </b-table>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" :options="options" @change="onLimitChange">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>

            <b-modal id="detail-informasi" title="Detail Informasi" no-close-on-backdrop >
                <div v-if="loadDetail">
                    <div class="text-center my-2">
                        Mengambil data, mohon menunggu...
                    </div>
                </div>
                <div v-else>
                    <div v-if="Informasi != null" class="detail-data-wrapper mb-4">
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">Judul Informasi</b-col>
                            <b-col>{{ Informasi.title }}</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">Jenis Informasi</b-col>
                            <b-col>{{ Informasi.jenis.name }}</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">Tanggal Rilis</b-col>
                            <b-col>{{$helper.changeDateFormat(Informasi.tanggalRilis)}} {{$helper.changeDateFormatGetHour(Informasi.tanggalRilis)}}</b-col>
                        </b-row>
                        <b-row v-if="Informasi.roles.length != 0" class="mb-2">
                            <b-col cols="4" class="detail-data-label">Ditujukan Kepada</b-col>
                            <b-col >
                                <div v-for="item of Informasi.roles">
                                    <div>- {{ item.name }}</div>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">Konten Informasi</b-col>
                            <b-col>{{ Informasi.content }}</b-col>
                        </b-row>
                        <ul v-for="item of Informasi.attachments">
                        <li>
                            <div>
                                {{ item.name }}
                            </div>
                            <a :href="$baseFilePath + item.path" class="btn btn-sm btn-primary no-wrap" target="_blank" download>Buka File</a>
                        </li>
                        </ul>
                    </div>
                </div>

                <template v-slot:modal-footer="{ cancel }">
                    <b-button variant="pgiBtn" name="closePreviewBtn" @click="cancel()">
                        Tutup
                    </b-button>
                </template>
            </b-modal>

        </b-card>
        <ModalConfirm id="modal-confirm-delete" title="Confirm Delete Informasi Umum" :isSubmitting="isSubmitting" boldMessage="Entri yang sudah dihapus tidak dapat dikembalikan lagi!" desc="Apakah anda yakin untuk menghapus informasi umum ini?" @submit="onSubmitDelete()" />
        <ModalConfirm id="conf-switch-status" title="Confirm Ubah Status Informasi Umum" :isSubmitting="isSubmitting" desc="Apakah kamu yakin untuk mengubah status informasi ini?" @submit="onSwitchStatus()" />
    </div>
</template>

<script>
export default {
    name: 'informasi-umum',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            role: null,
            credential: null,
            input:{
                show: 10,
                filterTitle: null,
                filterJenis: null,
                filterIsActive: null
            },
            fields: [
                { key: "title", label: "Judul informasi"},
                { key: "jenis.name", label: "Jenis informasi" },
                { key: "tanggalRilis", label: "Tanggal Rilis" },       
                { key: "isActive", label: "Status" },       
                { key: "action", label: "Aksi"},
            ],
            filter: null,
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            listinformasi: [],
            jenisinformasi: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: "",
            activeDeleteId: null,
            isSubmitting: false,

            loadDetail: false,
            Informasi: null,
            activeId : null,
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)
            this.role = localStorage.role

            let getCredentials = this.$axios.get("/informasi-umum/input-edit-allowed").then(response => {
                this.credential = response.data
                if (this.credential.id == 0) this.fields[5] = {}
            })

            let getJenisinformasi = this.$axios.get('informasi-umum/jenis').then(response => {
                this.jenisinformasi = response.data
            })

            let getinformasi = this.$axios.get("informasi-umum/"+this.query).then(response => {
                this.listinformasi = response.data.data
                this.updateTotalItem(response.data.total)
            })

            Promise.all([getJenisinformasi, getinformasi, getCredentials]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },


        //----------------- Fungsi Ambil Data Promo -----------------

        getinformasi(){
            this.toggleBusy()
            this.listinformasi = []

            if(this.input.filterJenis != null) this.query = this.query + "&filterJenis=" + this.input.filterJenis
            if(this.input.filterIsActive != null && this.credential.id == 1) this.query = this.query + "&filterIsActive=" + this.input.filterIsActive
            if(this.input.filterTitle != null) this.query = this.query + "&filterTitle=" + this.input.filterTitle
            if(this.input.sortBy != null) this.query = this.query + "&sortBy=" + this.input.sortBy
            if(this.input.sortDesc != null) this.query = this.query + "&sortDesc=" + this.input.sortDesc

            this.$axios.get("informasi-umum/"+this.query).then(response => {
                this.listinformasi = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

        getDetail(id){
            this.$bvModal.show('detail-informasi')
            this.loadDetail = true
            this.$axios.get(`informasi-umum/${id}`).then(response => {
                this.Informasi = response.data
                this.loadDetail = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.loadDetail = false
            })
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------
        
        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getinformasi()
        },

        onPageChange(){
            if (this.loading == false) {
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getinformasi()
            }
        },

        sortingChanged(ctx) {
            if(ctx.sortBy != ""){
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset(){
            this.input.filterJenis = null
            this.input.filterIsActive = null
            this.input.filterTitle = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getinformasi()
        },

        onFilter(){
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getinformasi()
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        inputinformasiUmum(){
            this.$router.push({path: `${this.$route.path}/input`});
        },

        openConfirmDelete(id){
            this.$bvModal.show("modal-confirm-delete")
            this.activeDeleteId = id;
        },

        onSubmitDelete(){
            
            this.isSubmitting = true

            this.$axios.post(`informasi-umum/delete/?id=${this.activeDeleteId}`).then(response => {
                this.$helper.toastSucc(this, "Informasi umum berhasil dihapus!")
                this.$bvModal.hide("modal-confirm-delete")
                let idx = this.listinformasi.findIndex(item => item.id == this.activeDeleteId);
                this.listinformasi.splice(idx, 1)
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        confSwitchStatus(id){
            this.activeId = id
            this.$bvModal.show('conf-switch-status')
        },
        
        onSwitchStatus(){
            this.isSubmitting = true

            this.$axios.post(`informasi-umum/switch-active?id=${this.activeId}`).then(response => {
                this.$helper.toastSucc(this, "Status Informasi umum berhasil diubah!")
                this.$bvModal.hide("conf-switch-status")
                this.getinformasi()
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        }

    },

    created(){
        this.init()
    }
}
</script>
